import { inject, ElementRef } from '@angular/core';

export function appInjectElement<T = HTMLElement>(): T {
  return inject(ElementRef).nativeElement;
}
